
component is : {{component}}
<div class="job-ad">
    <h4>{{ headline }}</h4>
    {{ body }}
  </div>